import { useMutation } from '@tanstack/react-query'
import { createExperienceSelectionSession } from 'api/experiences'

export default function useCreateExperienceSelectionSession() {
  return useMutation({
    mutationFn: (offerId: string) => createExperienceSelectionSession(offerId),
  })
}
